import { useMemo } from 'react';

import { isDefined } from '@pflegia/util/functions/type-guards';

const FAQ_MODELS = ['model1', 'model2', 'model3'] as const;
const HASH_MULTIPLIER = 31;

const getModelIndexFromId = (identifier: string) =>
  Array.from(identifier)
    .map(char => char.charCodeAt(0))
    .reduce((hash, code) => (hash * HASH_MULTIPLIER + code) >>> 0, 0) % FAQ_MODELS.length;

export const useRandomizedFaqModel = (jobId: string) =>
  useMemo(() => {
    if (!isDefined(jobId)) return FAQ_MODELS[0];

    return FAQ_MODELS[getModelIndexFromId(jobId)];
  }, [jobId]);
